import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the Emergent Google Auth return: exchanges the one-time session_id
// (URL fragment) for a persistent session via the backend, then redirects.
const AdminAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(
      (location.hash || "").replace(/^#/, "")
    ).get("session_id");

    if (!sessionId) {
      navigate("/admin/login", {
        replace: true,
        state: { error: "Sign-in did not complete. Please try again." },
      });
      return;
    }

    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (r) => {
        if (!r.ok) {
          const data = await r.json().catch(() => ({}));
          throw new Error(data.detail || "Sign-in failed");
        }
        return r.json();
      })
      .then((user) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((e) =>
        navigate("/admin/login", { replace: true, state: { error: e.message } })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="flex min-h-[70vh] items-center justify-center"
      data-testid="auth-callback"
    >
      <p className="text-sm font-semibold text-charcoal/50">Signing you in…</p>
    </div>
  );
};

export default AdminAuthCallback;
